import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import basketSelector from 'selectors/basket/basketSelector';
import availableRrcCouponsSelector from 'selectors/availableRrcCoupons/availableRrcCouponsSelector';
import promoErrorSelector from 'selectors/promo/promoError/promoErrorSelector';
import promoUtils from 'utils/Promos';
import localeUtils from 'utils/LanguageLocale';
import {
    applyRougeCashReward,
    removeRougeCashReward,
    showRougeRewardLearnMoreModal
} from 'actions/RougeRewardsActions';
import Empty from 'constants/empty';

const { wrapHOC } = FrameworkUtils;

const fields = createSelector(
    userSelector,
    availableRrcCouponsSelector,
    basketSelector,
    promoErrorSelector,
    (user, availableRrcCoupons, basket, promoError) => {
        const bankRewards = user.ccRewards?.bankRewards || Empty.Object;
        const rrcCoupons = availableRrcCoupons?.coupons || Empty.Array;

        const { promoCode, errorMessages } = promoUtils.extractError(
            { promoError },
            [promoUtils.CTA_TYPES.CBR]
        );
        const errorMessage = errorMessages?.length ? errorMessages.join(' ') :
            null;

        //BI cash
        const hasDcItems = (basket.items?.length || 0) > 0;
        const hasPickupItems = (basket?.pickupBasket?.itemCount || 0) > 0;
        const selectedBasket = hasDcItems ? basket : (hasPickupItems ? basket.pickupBasket : basket);

        const cbr = {
            isAvailable: selectedBasket.availableCBRPromotions?.length > 0,
            promos: selectedBasket.availableCBRPromotions || Empty.Array,
            availableCash: localeUtils.getFormattedPrice(selectedBasket.maxEligibleCBR, false, false),
            appliedValue: localeUtils.getFormattedPrice(selectedBasket.appliedCBRValue, false, false),
            biPoints: selectedBasket.netBeautyBankPointsAvailable,
            subtotal: selectedBasket.subtotal,
            rawSubTotal: selectedBasket.rawSubTotal,
            error: {
                message: errorMessage,
                couponCode: promoCode?.toUpperCase() || null,
                isAvailable: errorMessage != null
            }
        };

        // Extract applied promo codes from basket (normalize to lowercase for case-insensitive comparison)
        // Handle both string entries and object entries with couponCode property
        const appliedPromoCodes = (selectedBasket.appliedPromotions || Empty.Array)
            .map(promo => (typeof promo === 'string' ? promo : promo?.couponCode))
            .filter(Boolean)
            .map(code => code.toLowerCase());


        return {
            bankRewards,
            availableRrcCoupons: rrcCoupons,
            basket,
            appliedPromoCodes,
            isDualBasket: hasDcItems && hasPickupItems,
            cbr
        };
    }
);

const functions = dispatch => ({
    onApplyRougeReward: couponCode => dispatch(applyRougeCashReward(couponCode)),
    onRemoveRougeReward: couponCode => dispatch(removeRougeCashReward(couponCode)),
    onShowLearnMore: coupon => dispatch(showRougeRewardLearnMoreModal(coupon))
});

const withBeautyInsiderRewardsSummaryProps = wrapHOC(connect(fields, functions));

export {
    withBeautyInsiderRewardsSummaryProps, fields, functions
};
